// extracted by mini-css-extract-plugin
export var chip = "_5o-9";
export var chipLabel = "_5o-a";
export var close = "_5o-7";
export var closeIcon = "_5o-8";
export var error = "_5o-6";
export var infoTooltip = "_5o-2";
export var innerContainer = "_5o-1";
export var input = "_5o-b";
export var medium = "_5o-5";
export var outerContainer = "_5o-0";
export var small = "_5o-4";
export var xSmall = "_5o-3";